module.exports = __webpack_public_path__ + "img/sleeve binding width.6fb1fc53.png";